module.exports = __webpack_public_path__ + "static/media/poemu.aba6b349.jpg";